skrilla.directive('queryUserBettingStatistics', function ($window, betService) {
    return {
        templateUrl: 'directives/queryUserBettingStatistics/queryUserBettingStatistics.html',
        scope: {
            stats: "=",
            key: "=",
            queryKey: "=",
            userId: "=",
            marketId: "=",
            subtitle: "="
        },
        controller: async function ($scope,
                                    searchService,
                                    queryService,
                                    paginationService,
                                    cacheService,
                                    sportService) {
            $scope.sports = await sportService.getSportsByUser($scope.userId);
            $scope.sportsLabels = {}
            $scope.sports.forEach(function (sport) {
                $scope.sportsLabels[sport.first] = sport.first + " (" + sport.second + ")"
            })
            $scope.queryKey = $scope.queryKey || "queryUserBettingStatistics";

            $scope.setUser = function () {
                $scope.query.userId = $scope.userId === undefined ? "" : $scope.userId;
            }
            $scope.reset = function () {
                $scope.query = {
                    sports: {

                    },
                    sources: {
                        AVAILABLE: true,
                        PROMOTION_USER: true,
                    },
                };
                $scope.sports.forEach(function (sport) {
                    $scope.query.sports[sport.first] = false
                })
                $scope.setUser()
                $scope.loading = false;
            };
            $scope.reset()

            $scope.search = function () {
                $scope.loading = true
                searchService.get("users/" + $scope.userId + "/bettingStatistics" + queryParams(), true, true)
                    .then(function (response) {
                        $scope.stats = response.data;
                    }).finally(() => {
                        $scope.loading = false;
                    });
            }
            $scope.search()

            function queryParams() {
                cacheService.registerObject($scope.queryKey, $scope.query)
                const queryParams = queryService.getQueryString($scope.query, $scope.key);
                return queryParams;
            }

            $scope.btnPress = function (keyEvent) {
                if (keyEvent.which === 13)
                    $scope.search();
            }
        }
    };
});